export enum SortedBy {
  Default = 'Default',
  Rating = 'Rating',
  DeliveryFee = 'DeliveryFee'
}
